export enum DiscountType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage',
}
